import React from "react";
import { classNames } from "lib/utils/helpers";

interface ConsentToggleProps {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}

const ConsentToggle: React.FC<ConsentToggleProps> = ({ checked, disabled = false, onChange, label }) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={classNames(
        "relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors duration-200 outline-none",
        checked ? "bg-[#27272a]" : "bg-[#e4e4e7]",
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
      )}>
      <span
        className={classNames(
          "inline-block h-4 w-4 rounded-full bg-white shadow-[0_1px_2px_rgba(0,0,0,0.12)] transition-transform duration-200",
          checked ? "translate-x-[18px]" : "translate-x-0.5",
        )}
      />
    </button>
  );
};

export default ConsentToggle;
